// extracted by mini-css-extract-plugin
export default {"paragraphContainer":"HomeAbout_paragraphContainer__tc1Bj","downloadButton":"HomeAbout_downloadButton__Bneoz","seeMoreButton":"HomeAbout_seeMoreButton__t35O+"};